(function () {
	/**
	 * Convert radio buttons to stars
	 * @version 1.1.0
	 * @author Aleš Gabriel, Jaroslav Slaby <gabriel@avast.com>, <slaby@avast.com>
	 * @module avast.web.rating
	 * @param {NodeList} Array of radio button elements
	 * @returns Object of methods
	 */
	avm.define('avast.web.rating', function (radios) {
		return {
			radios: radios,
			stars: function () {
				var rating = this,
					allStars = $('<div class="rating-stars">'),
					radios = this.radios,
					stars = [];

				this.allStars = allStars;

				radios.forEach(function (radio, index, array) {
					stars.push($('<div class="rating-star selected">').data('value', radio.value).get(0));
				});

				allStars.on('click', '.rating-star', function () {
					rating.rateClick.apply(rating, arguments); // TODO: Or function.bind()? Support for forEach and bind is almost the same
				});
				allStars.append(stars);

				if (allStars.length) {
					this.hideRadios(radios);
				}

				return allStars;
			},
			rateClick: function (evt) {
				var star = $(evt.currentTarget);

				this.lightUpStars(star);
				this.rateOnRadios(star.data('value'), this.radios);
			},
			hideRadios: function (radios) {
				$(radios).hide();
			},
			lightUpStars: function (star) {
				star.removeClass('selected');
				star.siblings().removeClass('selected');
				star.prevAll().addClass('selected');
				star.addClass('selected');
			},
			rateOnRadios: function (value, radios) {
				radios.forEach(function (radio) {
					if (radio.value === value) {
						radio.checked = true;
					}
				});
			},
			destroy: function () {
				$(this.radios).show();
				this.allStars.off('click');
				this.allStars.remove();
			}
		}
	})

	/**
	 * Parse JSON to microdata reviews
	 * @version 1.1.0
	 * @author Aleš Gabriel, Jaroslav Slaby <gabriel@avast.com>, <slaby@avast.com>
	 * @module avast.web.review
	 * @returns Object of methods
	 * @description Expected JSON data structure:
		[
			{
				"date": "2015-10-24T04:43:04.8019109Z",
				"name": "n",
				"rating": 4,
				"text": "this is the best antivirus"
			}
		]
	 */
	avm.define('avast.web.review', (function (data) {
		var $ = avm.require('cash')
		return {
			reviews: data ? JSON.parse(data) : JSON.parse(document.getElementById('avast-adc-reviews').innerHTML),
			fetch: function (from, to) {
				var ratings = [],
					from = from || 0,
					to = to || this.reviews.length,
					reviews = this.reviews.slice(from, to);

				reviewsDOM = $.fn.map(reviews, function (review) {
					var d = new Date(review.date)
					var day = d.getDate();
					var month = d.getMonth() + 1;
					var year = d.getFullYear();

					var prefix = 'slider-review-',
						slide = $('<div itemscope itemtype="http://schema.org/Review">').addClass(prefix + 'slide'),

						thing = $('<div itemprop="itemReviewed" itemscope itemtype="http://schema.org/Product">').addClass(prefix + 'thing'),
						thingValue = $('<span itemprop="name">AVS</span>').text('Avast Free Antivirus for Windows 10'),
						name = $('<div itemprop="author" itemscope itemtype="http://schema.org/Person">').addClass(prefix + 'author'),
						nameValue = $('<span itemprop="name">').text(review.name),
						rating = $('<div itemprop="reviewRating" itemscope itemtype="http://schema.org/Rating">').addClass(prefix + 'rating'),
						ratingValue = $('<span itemprop="ratingValue">').text(review.rating),
						stars = new Array(review.rating)
					text = $('<p itemprop="reviewBody">').addClass(prefix + 'text').text(review.text),
						date = $('<span itemprop="datePublished">').text(day + '/' + month + '/' + year).addClass(prefix + 'date');

					for (var i = 0; i < parseInt(review.rating); i++) {
						rating.append('<span class="star">');
					}

					slide.append([thing.append(thingValue), name.append(nameValue), date, rating.append(ratingValue), text]);
					ratings.push(parseInt(review.rating));

					return slide;
				});

				return reviewsDOM;
			}

		}
	})());

	// NEW form loader
	var $ = avm.require('cash'),
		rateButton = ('.rateButton'),
		formLoaded = false,
		url = avastGlobals.web.RootPath ? avastGlobals.web.RootPath + locale + '/' + 'rating-form.php' : 'rating-form.php';

	$(rateButton).on('click', function () {
		if (!formLoaded) {

			var xhr = new XMLHttpRequest();
			xhr.open('GET', url);
			xhr.setRequestHeader('X-Requested-With', 'XmlHttpRequest');
			xhr.onreadystatechange = function () {
				if (xhr.readyState !== 4) return;
				if (xhr.status === 200) {
					renderForm(xhr.responseText)
				}
			};
			xhr.send();

			function renderForm(content) {
				$('#rate').addClass('rating-form');

				$('#ratingForm').append(content, function () {
					formLoaded = true;
					var rating = avm.require('avast.web.rating')($('.rating-form').find('input[type="radio"][name="rating"]').get()),
						stars = rating.stars();

					initAvastForm();

					$('.rating-form').find('input[type="radio"][name="rating"]')
						.closest('.form-item')
						.hide()
						.before($('<div>').addClass('form-item').append(stars));

					// Form tweaks
					$('.rating-form').find('#frm-text').attr('maxlength', '300');
				})
			}
		}

	});
})();

$(document).ready(function () {
	//console.time('buildSlides')
	var reviewModule = avm.require('avast.web.review');
	reviews = reviewModule.reviews;
	bxFetchSlide = 0,
		ratingPoints = 5;

	// Total reviews and average rating to DOM
	var totalRatings = reviews.reduce(function (pv, cv) { return pv + cv.rating; }, 0);
	var avgRating = (totalRatings) / reviews.length;
	var percentAvgRating = Math.floor((100 / ratingPoints) * avgRating);

	$('.rating-bar').width(30 * ratingPoints);
	$('.rating-bar-average').width(percentAvgRating + '%');

	$('.total-reviews').text(reviews.length)
	$('.average-rating').text(avgRating.toPrecision(2))
	//console.timeEnd('buildSlides')
});
